import React, { useEffect, useState } from 'react'
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

// import Layout from "../components/layout"
import Seo from "../components/seo"

import { navigate } from 'gatsby';

import Main from '../features/main';
import Preregistration from '../features/preregistration';

// const IndexPage1 = () => {
//     useEffect(() => {
//         navigate('/preregistration');
//     }, []);

//     return (
//         <div></div>
//     );
// }

// export default IndexPage;
export default Main;
// export default Preregistration;
// const IndexPage = () => {
//     const [view, setView] = useState(undefined);

//     useEffect(() => {
//         // javascript Date에서 month는 1을 빼줘야함
//         const baseDate = new Date(2023, 3, 1, 0, 0, 0);
//         const now = new Date();

//         setView(now < baseDate ? 'preregistration' : 'main');
//     }, []);

//     if(view === undefined)
//         return <></>;

//     return (
//         <>
//             {view === 'main' ? <Main /> : <Preregistration />}
//         </>
//     );
// }

// export default IndexPage;
